import React, {Fragment, useEffect} from 'react'
import { Container, Dropdown, Divider, Grid, Header, Image, List, Menu, Segment, Icon, Modal, Button, Breadcrumb } from 'semantic-ui-react'
import {__PREFIX__} from '../constants/UrlPrefix'
import { useSelector, useDispatch } from 'react-redux'
import { useFirebase, isLoaded, useFirestore, useFirestoreConnect } from 'react-redux-firebase'
import { router } from '../reducers'
import * as RouterActions from '../actions/RouterActions.js';
import {env} from '../constants/Environment';

export const Navigation = function(props){
    const profile = useSelector(({ firebase: { auth } }) => auth)
    const firebase = useFirebase()
    const firestore = useFirestore();

    const dispatch = useDispatch()
    useFirestoreConnect([
        { collection: 'environments/' + env + '/users/' + profile.email + '/permissions', doc: 'cms' }
    ])
    let permissionsSet = useSelector(({firestore}) => (
        typeof profile !== 'undefined' && profile !== null && 
        typeof firestore.data !== 'undefined' &&
        typeof firestore.data['environments/' + env + '/users/' + profile.email + '/permissions'] !== 'undefined' && 
        typeof firestore.data['environments/' + env + '/users/' + profile.email + '/permissions'].cms !== 'undefined' && 
        firestore.data['environments/' + env + '/users/' + profile.email + '/permissions'].cms !== null
    )?
        firestore.data['environments/' + env + '/users/' + profile.email + '/permissions'].cms
    :{});

    useEffect(() => {
        if(typeof profile.email !== 'undefined' && profile.email !== null){
            (async () => {
                let userDoc = await firestore.collection('environments/' + env + '/users').doc(profile.email).get();
                if(!userDoc.exists){
                    await firestore.collection('environments/' + env + '/users').doc(profile.email).set({
                        name: profile.displayName,
                        email: profile.email,
                        created: new Date()
                    });
                }
            })();
        }
    }, [profile.email]);

    const authorized = (role) => (typeof permissionsSet[role] !== 'undefined' && permissionsSet[role].read === true);

    function signOut(){
        firebase.auth().signOut().then(function() {
            // Sign-out successful.
        }).catch(function(error) {
            // An error happened.
        });
    }

    return (
        <div>
            <Menu borderless fixed='top' style={{
					backgroundColor: '#f4f4f4',
					boxShadow: 'none',
					fontFamily: 'Roboto',
					fontWeight: 300
				}}>	

            		<Dropdown item text={<span><Icon name={props.icon} />  {props.title}</span>} style={{backgroundColor: 'rgb(0, 110, 215)', color: '#FFFFFF'}} >
                        <Dropdown.Menu>
                            {
                        		(false && authorized(['realm-management:view-users']))?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/storelocator/'))}><Icon name="location arrow" /> Store-Locator</Dropdown.Item>
                            	:null
                            }
                            {
                        		(authorized(['marketing-displays']))?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/displays/'))}><Icon name="film" /> Marketing-Displays</Dropdown.Item>
                            	:null
                            }
                            {
                        		(true)?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/bookmaker/eventticker'))}><Icon name="tasks" /> Eventticker</Dropdown.Item>
                            	:null
                            }
                            {
                        		(authorized(['staticfiles']))?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/staticfiles/files/'))}><Icon name="file alt" /> Statische Dateien</Dropdown.Item>
                            	:null
                            }
                            {
                        		(authorized(['stories']))?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/stories/'))}><Icon name="newspaper" /> Beiträge</Dropdown.Item>
                            	:null
                            }
                            {
                        		(false && authorized(['realm-management:view-users']))?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/app/home'))}><Icon name="mobile" /> App</Dropdown.Item>
                            	:null
                            }
                            {
                        		(authorized(['canvas']))?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/canvas/'))}><Icon name="cloud" /> Canvas</Dropdown.Item>
                            	:null
                            }
                        	{
                        		(false && authorized(['realm-management:view-users']))?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/system/'))}><Icon name="cloud" /> System</Dropdown.Item>
                            	:null
                            }
                            {
                        		( authorized(['users']))?
                            		<Dropdown.Item onClick={() => dispatch(RouterActions.push('/system/users'))}><Icon name="cogs" /> System</Dropdown.Item>
                            	:null
                            }
                        </Dropdown.Menu>
                    </Dropdown>

                    {
                    	(typeof props.menu !== 'undefined')?
	                    	props.menu.map((menu, idx) => {
	                    		if(typeof menu.auth !== 'undefined' && !this.authorized(menu.auth))return null;
	                    		
	                    		if(typeof menu.entries === 'undefined')
	                    			return (
	                    				<Menu.Item key={idx} onClick={menu.onClick} active={menu.active}>
	                    					<Icon name={menu.icon} />
		                    				{menu.caption}
	                    				</Menu.Item>
	                    			)
	                    		else
		                    		return (
		                    			<Dropdown key={idx} item text={(
		                    				<span>
		                    					<Icon name={menu.icon} />
		                    					{menu.caption}
		                    				</span>
		                    			)} style={{fontWeight: 300}}>
			                    			<Dropdown.Menu>
			                    			{
			                    				menu.entries.map((entry, eidx) => {
			                    					if(typeof entry.auth !== 'undefined' && !this.authorized(entry.auth))return null;
			                    					
			                    					return (
			                    						<Dropdown.Item key={eidx} href={entry.href}>
			                    							<Icon name={entry.icon} />
			                    							{entry.caption}
			                    						</Dropdown.Item>
			                    					)
			                    				})
			                    			}
			                    			</Dropdown.Menu>
		                    			</Dropdown>
		                			)
	
	                    	})
                    	:null
                    }

            <Menu.Menu position='right'>
	        
                {
                    (typeof profile === 'undefined' || profile === null)?
                        null
                    :
                    <Dropdown item text={
                        <span>
                            <Icon name="user" />
                            {
                                profile.displayName
                            }
                        </span>
                    } style={{fontWeight: 300}} >
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => {
                                signOut();
                            }}><Icon name="lock" /> Abmelden</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                }
        
                    </Menu.Menu>
            </Menu>
            {
                (typeof props.breadcrumb !== 'undefined' && props.breadrumb !== null)?
                <div style={{
                    backgroundColor: '#EEEEEE',
                    marginTop: '41px',
                    position: 'fixed',
                    padding: '10px',
                    width: '100%',
                    borderBottom: '1px solid #cccccc'
                }}>
                    {
                        props.breadcrumb.map((breadcrumb, idx) => {
                            return <Fragment key={idx}>{idx?<span style={{color: '#555555'}}> / </span>:null}<a style={{
                                cursor: 'pointer'
                            }} onClick={(e) => dispatch(RouterActions.push(breadcrumb.href))}>{breadcrumb.caption}</a></Fragment>
                        })
                    }
                </div>
                :null
            }
            <Container fluid style={{
                fontFamiliy: 'Roboto',
                fontWeight: 400,
                paddingTop: (typeof props.breadcrumb !== 'undefined' && props.breadrumb !== null)?'81px':"41px"
            }}>
                {props.children}
            </Container>
        </div>
    )
}